import styled from 'styled-components'
import { AccommodationPackageTileGrid } from './AccommodationSameRoomOptionTile'

export const AccommodationSameRoomOptionTileSubgrid = styled.div`
  display: grid;

  @supports (grid-template-rows: subgrid) {
    grid-row: span 2;
    grid-template-rows: subgrid;

    & > ${AccommodationPackageTileGrid} {
      grid-row: 2;
    }
  }
`
